module.exports = __webpack_public_path__ + "img/IMG_1645_Black_MockedUp.cf770afe.jpg";